module.exports = __webpack_public_path__ + "static/media/p4_s6.af1d1483.ogg";